import React from 'react';
import { AppBar, Toolbar, Typography, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Header = () => {

  return (
    <AppBar position="static" color="primary">
      <Toolbar>
        <Typography variant="h5" component="div" sx={{ flexGrow: 1 }}>
          Steffen Straub
        </Typography>

        <Button color="inherit" component={RouterLink} to="/">
          Home
        </Button>
        
        <Button
          color="inherit"
          component="a"
          href={`${process.env.PUBLIC_URL}/cv.pdf`}
          download="cv.pdf"
        >
          CV
        </Button>
        <Button color="inherit" href="mailto:steffen@straub-versicherungen.de">
          Email
        </Button>
        <Button color="inherit" href="https://www.linkedin.com/in/steffen-straub-388709235" target="_blank">
          LinkedIn
        </Button>
        
      </Toolbar>
    </AppBar>
  );
};

export default Header;